import { useCallback } from "react";
import { PanelFooter } from "../../../../components/Panel/PanelFooter";
import { IOpenPanel } from "../../../../Interfaces/IPanel";
import { UsePanelEquipoSync } from "./UsePanelEquipoSync";
import { PanelDrawer } from "../../../../components/Panel/PanelDrawer";

export const PanelEquipoSync=(props:IOpenPanel)=>{
    const {reset,status,mensaje,loading,Syncronizar} = UsePanelEquipoSync(props)
     const onRenderFooter = useCallback(
        () => (
          <>

          </>
        ),
        []
      );
    return (
         <PanelDrawer isOpen={props.isOpen} onDismiss={reset} 
            onRenderFooter={onRenderFooter}
            textHeader={"Actualizar según Dispatch"} status={status} mensaje={mensaje} 
            loading={loading}>



        </PanelDrawer>
    )
}